<template>
  <div>
    <div class="formStyle">
      <div>
        <h3 id='paragraph1'>1. Produkt leczniczy</h3>
        <div class='indent'>
          <div>
            1.1. ID <strong v-if='formData.id'> {{formData.id}}</strong><i v-else>Numer id zostatnie przyznany po zatwierdzeniu formularza</i>
          </div>
          <div>
            1.2. Substancja czynna <br>
            <textarea class="textareaForm" v-model="formData.subst_czynna" rows="1" ></textarea>
          </div>
          <div>
            1.3. Nazwa produktu leczniczego <br>
            <textarea class="textareaForm" v-model="formData.lek" rows="1" ></textarea>
          </div>
          <div>
            1.4. Kod ATC <br>
            <textarea class="textareaForm" v-model="formData.kod_atc" rows="1" placeholder='do zdefiniowania lista rozwijana'></textarea>
          </div>
          <div>
            1.5. Wskazanie rejestracyjne <br>
            <textarea class="textareaForm" v-model="formData.wskazania_rejestracyjne" rows="1" ></textarea>
          </div>
          <div>
            1.6. Wskazanie oceniane <br>
            <textarea class="textareaForm" v-model="formData.wskazanie_oceniane" rows="1" ></textarea>
          </div>
          <div>
            1.7. Wiek <br>
            <model-select :options="wiekOptions"
                          v-model="formData.wiek"
                          class="searchSelect"
                        ></model-select>
          </div>
          <div>
            1.8. Status Orphan
            <label class='indent'>
              <input type="radio" v-model='formData.status_orphan' :value='true'>Tak
            </label>
            <label>
              <input type="radio"  v-model='formData.status_orphan' :value='false'>Nie
            </label>
          </div>
          <div>
            1.9. Stosowany w onkologii
            <label class='indent'>
              <input type="radio" v-model='formData.onkologia' :value='true'>Tak
            </label>
            <label>
              <input type="radio"  v-model='formData.onkologia' :value='false'>Nie
            </label>
          </div>
          <div>
            1.10. Czy lek biopodobny 
            <label class='indent'>
              <input type="radio" v-model='formData.biopodobny' :value='true'>Tak
            </label>
            <label>
              <input type="radio"  v-model='formData.biopodobny' :value='false'>Nie
            </label>
          </div>
          <div>
            1.11. Czy lek generyczny 
            <label class='indent'>
              <input type="radio" v-model='formData.genereczny' :value='true'>Tak
            </label>
            <label>
              <input type="radio"  v-model='formData.genereczny' :value='false'>Nie
            </label>
          </div>
          <div>
            1.12. Data dopuszczenia do obrotu EMA
            <input type="date" v-model="formData.data_dopuszczenia" class='dateForm indent' @input='changeRejestracja2017()'/>
          </div>
          <div>
            1.13. Podmiot odpowiedzialny <br>
            <textarea class="textareaForm" v-model="formData.podmiot_odpowiedzialny" rows="1" ></textarea>
          </div>
          <div>
            1.14. Postać farmaceutyczna <br>
            <textarea class="textareaForm" v-model="formData.postac_farmaceutyczna" rows="1" placeholder='do zdefiniowania lista rozwijana'></textarea>
          </div>
          <div>
            1.15. Droga podania <br>
            <textarea class="textareaForm" v-model="formData.droga_podania" rows="1" ></textarea>
          </div>
          <div>
            1.16. Dawkowanie leku <br>
            <textarea class="textareaForm" v-model="formData.dawkowanie" rows="1" ></textarea>
          </div>
          <div>
            1.17. Schemat leczenia <br>
            <textarea class="textareaForm" v-model="formData.schemat_leczenia" rows="1" ></textarea>
          </div>
          <div>
            1.18. Czas leczenia <br>
            <model-select :options="czasLeczeniaOptions"
                          v-model="formData.czas_lecznia"
                          class="searchSelect"
                        ></model-select>
          </div>
          <div class='indent' v-if='formData.czas_lecznia == "inny"'>
            1.18.1. Czas leczenia - opis <br>
            <textarea class="textareaForm" v-model="formData.czas_leczenia_opis" rows="1" ></textarea>
          </div>
          <div>
            1.19. Szczegółowe warunki stosowania <br>
            <textarea class="textareaForm" v-model="formData.warunki_stosowania" rows="1" ></textarea>
          </div>
          <div>
            1.20. Badania diagnostyczne <br>
            <textarea class="textareaForm" v-model="formData.badania_diagnostycznie" rows="1" ></textarea>
          </div>
          <div class='indent'>
            1.20.1. Badania przy kwalifikacji <br>
            <textarea class="textareaForm" v-model="formData.badania_kwalifikacja" rows="1" ></textarea>
          </div>
          <div class='indent'>
            1.20.2. Badania przy monitorowaniu <br>
            <textarea class="textareaForm" v-model="formData.badania_monitorowanie" rows="1" ></textarea>
          </div>
          <div>
            1.21. Komentarz <br>
            <textarea class="textareaForm" v-model="formData.komentarz_produkt" rows="1" ></textarea>
          </div>
        </div>
      </div>
      <hr>
      <div>
        <h3 id='paragraph2'>2. Status leku</h3>
        <div class='indent'>
          2.1. Podstawowa selekcja <br><br>
          <div class='indent'>
            <div>
              2.1.1. Czy rejestracja po 01.01.2017
              <label class='indent'>
                <input type="radio" v-model='formData.rejestracja2017' :value='true'>Tak
              </label>
              <label>
                <input type="radio"  v-model='formData.rejestracja2017' :value='false'>Nie
              </label>
            </div>
            <div>
              2.1.2. Czy jest finansowany na podstawie Obwieszczenia MZ
              <label class='indent'>
                <input type="radio" v-model='formData.finansowanie' :value='true'>Tak
              </label>
              <label>
                <input type="radio"  v-model='formData.finansowanie' :value='false'>Nie
              </label>
              <label>
                <input type="radio"  v-model='formData.finansowanie' :value='null'>Nie określono
              </label>
            </div>
            <div class='indent'>
              2.1.2.1. Komentarz
              <textarea class="textareaForm" v-model="formData.finansowanie_komentarz" rows="3" ></textarea>
            </div>
            <!-- <div>
              2.1.2. Czy zmiana warunków dopuszczenia do obrotu po 2017<br>
              <div class='indent'>
                <label>
                  <input type="radio" v-model='formData.zmiana_2017' value='nie dotyczy'>nie dotyczy,
                </label><br>
                <label>
                  <input type="radio" v-model='formData.zmiana_2017' value='nowa dawka - wskazanie to samo'>nowa dawka - wskazanie to samo,
                </label><br>
                <label>
                  <input type="radio" v-model='formData.zmiana_2017' value='nowa dawka i droga podania - wskazanie to samo'>nowa dawka i droga podania - wskazanie to samo,
                </label><br>
                <label>
                  <input type="radio" v-model='formData.zmiana_2017' value='nowa dawka i postać farmaceutyczna - wskazanie to samo'>nowa dawka i postać farmaceutyczna - wskazanie to samo,
                </label><br>              
                <label>
                  <input type="radio" v-model='formData.zmiana_2017' value='nowa droga podania - wskazanie to samo'>nowa droga podania - wskazanie to samo,
                </label><br>
                <label>
                  <input type="radio" v-model='formData.zmiana_2017' value='nowa postać farmaceutyczna - wskazanie to samo'>nowa postać farmaceutyczna - wskazanie to samo,
                </label><br>
                <label>
                  <input type="radio" v-model='formData.zmiana_2017' value='nowe wskazanie'>nowe wskazanie,
                </label><br>
                <label>
                  <input type="radio" v-model='formData.zmiana_2017' value='modyfikacja wskazania'>modyfikacja wskazania,
                </label><br>
                <label>
                  <input type="radio" v-model='formData.zmiana_2017' value='rozszerzenie wskazania'>rozszerzenie wskazania
                </label><br>
              </div>
            </div> -->
            <div>
              2.1.3. Czy spełnione kryteria oceny w ramach TLI
              <label class='indent'>
                <input type="radio" v-model='formData.kryteria_TLI' :value='true'>Tak
              </label>
              <label>
                <input type="radio"  v-model='formData.kryteria_TLI' :value='false'>Nie
              </label>
              <label>
                <input type="radio"  v-model='formData.kryteria_TLI' :value='null'>Nie określono
              </label>
            </div>
            <div>
              2.1.4. Czy dostępne badanie z grupą kontrolną
              <label class='indent'>
                <input type="radio" v-model='formData.badanie_grupakontrolna' value='Tak'>Tak
              </label>
              <label>
                <input type="radio"  v-model='formData.badanie_grupakontrolna' value='Nie'>Nie
              </label>
              <label>
                <input type="radio"  v-model='formData.badanie_grupakontrolna' value='Nie określono'>Nie określono
              </label>
            </div>
            <div>
              2.1.5. Czy dostępne badanie RCT
              <label class='indent'>
                <input type="radio" v-model='formData.badanie_RTC' :value='true'>Tak
              </label>
              <label>
                <input type="radio"  v-model='formData.badanie_RTC' :value='false'>Nie
              </label>
              <label>
                <input type="radio"  v-model='formData.badanie_RTC' :value='null'>Nie określono
              </label>
            </div>
            <div>
              2.1.6. Czy dostępne punkty końcowe związane z wyleczeniem
              <label class='indent'>
                <input type="radio" v-model='formData.punkty_wyleczenie' :value='true'>Tak
              </label>
              <label>
                <input type="radio"  v-model='formData.punkty_wyleczenie' :value='false'>Nie
              </label>
              <label>
                <input type="radio"  v-model='formData.punkty_wyleczenie' :value='null'>Nie określono
              </label>
            </div>
            <div class="indent">
              2.1.6.1. Czy wynik istotny statystycznie
              <label class='indent'>
                <input type="radio" v-model='formData.istotny_wyleczenie' :value='true'>Tak
              </label>
              <label>
                <input type="radio"  v-model='formData.istotny_wyleczenie' :value='false'>Nie
              </label>
              <label>
                <input type="radio"  v-model='formData.istotny_wyleczenie' :value='null'>Nie określono
              </label>
            </div>
            <div>
              2.1.7. Czy dostępne punkty końcowe związane z przeżyciem
              <label class='indent'>
                <input type="radio" v-model='formData.punkty_przezycie' :value='true'>Tak
              </label>
              <label>
                <input type="radio"  v-model='formData.punkty_przezycie' :value='false'>Nie
              </label>
              <label>
                <input type="radio"  v-model='formData.punkty_przezycie' :value='null'>Nie określono
              </label>
            </div>
            <div class="indent">
              2.1.7.1. Czy wynik istotny statystycznie
              <label class='indent'>
                <input type="radio" v-model='formData.istotny_przezycie' :value='true'>Tak
              </label>
              <label>
                <input type="radio"  v-model='formData.istotny_przezycie' :value='false'>Nie
              </label>
              <label>
                <input type="radio"  v-model='formData.istotny_przezycie' :value='null'>Nie określono
              </label>
            </div>
          </div>
          2.2. Dodatkowe informacje <br><br>
          <div class="indent">
            <div>
              2.2.1. Czy otrzymał ocenę Agencji
              <label class='indent'>
                <input type="radio" v-model='formData.ocena_agencji' :value='true'>Tak
              </label>
              <label>
                <input type="radio"  v-model='formData.ocena_agencji' :value='false'>Nie
              </label>
              <label>
                <input type="radio"  v-model='formData.ocena_agencji' :value='null'>Nie określono
              </label>
            </div>
            <div>
              2.2.2 Wynik oceny Agencji <br>
              <textarea class="textareaForm" v-model="formData.wynik_ocagencji" rows="3" placeholder="rekomendancja pozytywna/pozytywna warunkowa/negatywna"></textarea>
            </div>
            <div v-if='formData.finansowanie===false'>
              2.2.3. Czy otrzymał negatywną decyzję refundacyjną Ministra Zdrowia
              <label class='indent'>
                <input type="radio" v-model='formData.negatywna_decyzja' :value='true'>Tak
              </label>
              <label>
                <input type="radio"  v-model='formData.negatywna_decyzja' :value='false'>Nie
              </label>
              <label>
                <input type="radio"  v-model='formData.negatywna_decyzja' :value='null'>Nie określono
              </label>
            </div>
          </div>
          2.3. Podsumowanie podstawowej selekcji <br><br>
          <div class="indent">
            <div>
              2.3.1. Komentarz <br>
              <textarea class="textareaForm" v-model="formData.podstawowa_selekcjakom" rows="3" ></textarea>
            </div>
            <div>
              2.3.2. Czy zakwalifikowany do szczegółowej selekcji
              <label class='indent'>
                <input type="radio" v-model='formData.szczegolowa_selekcja' :value='true' >Tak
              </label>
              <label>
                <input type="radio"  v-model='formData.szczegolowa_selekcja' :value='false' >Nie
              </label>
              <label>
                <input type="radio"  v-model='formData.szczegolowa_selekcja' :value='null' >Nie określono
              </label>
            </div>
            <div class='indent' v-if='formData.szczegolowa_selekcja === false'>
              2.3.2.1. Przyczyna dyskwalifikacji <br>
              <model-select 
                  :options="disqualificationOptions"
                  v-model="formData.przyczyna_dyskwalifikacji"
                  class="searchSelect"
                ></model-select>
            </div>
          </div>
          2.4. Szczegółowa selekcja <br><br>
          <div class="indent">
            <div>
              2.4.1. Efekt zdrowotny - OS
              <textarea class="textareaForm" v-model="formData.efekt_os" rows="3" ></textarea>
            </div>
            <div>
              2.4.2. Efekt zdrowotny - Inny punkt końcowy
              <textarea class="textareaForm" v-model="formData.efekt_zdrowotny" rows="3" ></textarea>
            </div>
            <div>
              2.4.3. Wartość LYG 
              <textarea class="textareaForm" v-model="formData.lyg" rows="1" ></textarea>
            </div>
          </div>
          2.5. Podsumowanie szczegółowej selekcji <br><br>
          <div class="indent">
            <div>
              2.5.1. Komentarz
              <textarea class="textareaForm" v-model="formData.podsumowanie_selekcji_kom" rows="3" placeholder='podsumowanie każdej dokonanej oceny'></textarea>
            </div>     
          </div>
          2.6. Ocena Rady Przejrzystości
          <textarea class="textareaForm" v-model="formData.ocena_rady_przejrzystości" rows="3" ></textarea>
          <br><br>
          2.7. Czy ujęty w wykazie TLK
          <label class='indent'>
            <input type="radio" v-model='formData.status_tlk' :value='true'>Tak
          </label>
          <label>
            <input type="radio"  v-model='formData.status_tlk' :value='false'>Nie
          </label>
          <label>
            <input type="radio"  v-model='formData.status_tlk' :value='null'>Nie określono
          </label>
        </div>
      </div>
      <hr>
      <div>
        <h3 id='paragraph3'>3. Ocena niezaspokojonej potrzeby zdrowotnej</h3>
        <div class='indent'>
          <div>
            3.1 Problem zdrowotny<br><br>
            <div class='indent'>
              <div>
                3.1.1. ICD-10 <br>
                <textarea class="textareaForm" v-model="formData.icd_10" rows="1" placeholder="pole wyboru"></textarea>
              </div>
              <div>
                3.1.2. Problem zdrowotny <br>
                <textarea class="textareaForm" v-model="formData.problem_zdrowotny" rows="3"></textarea>
              </div>
              <div>
                3.1.3. Obszar terapeutyczny <br>
                <textarea class="textareaForm" v-model="formData.obszar_terapeutyczny" rows="3"></textarea>
              </div>
              <div>
                3.1.4. Komentarz <br>
                <textarea class="textareaForm" v-model="formData.problem_zdrowotny_kom" rows="3"></textarea>
              </div>
            </div>
          </div>
          <div>
            3.2. Informacje o obciążeniu chorobowym (na podstawie GBD 2019) <br><br>
            <div class='indent'>
              <div>
                3.2.1.  Wskazanie dla DALY/YLL <br>
                <textarea class="textareaForm" v-model="formData.wskazanie_daly_yll" rows="3"></textarea>
              </div>
              <div>
                3.2.2. DALY (liczba bezwzględna)
                <input type="text" v-model="formData.daly_bezwzgledny" class='dateForm indent'/>
              </div>
              <div>
                3.2.3. DALY/100 tys. (wsk. surowy)
                <input type="text" v-model="formData.daly_100" class='dateForm indent' />
              </div>
              <div>
                3.2.4. Analiza trendu wskaźnika DALY w latach 1990-2019 
                 <input class="file" type="file" id="filesFirst" :ref="'filesFirst'"  multiple v-on:change="handleFileUploadsFirst('filesFirst')" accept="image/*"/>
                  <button type="button" class="buttonRDTL" @click="addFilesFirst('filesFirst')" >Dodaj załącznik</button>
              <!-- <div v-for="(file, key) in files" :key='key' class="file-listing"> -->
                <span v-if="(formData.daly_jpg)" class="download padding" @click="getFileFirst('filesFirst')">{{ filename(formData.daly_jpg) }} </span>
                <span v-if="(formData.daly_jpg)" class="padding remFile" v-on:click="removeFileFirst('filesFirst')">X</span>

              </div>
              <div>
                3.2.5. YLL (liczba bezwzględna)
                <input type="text" v-model="formData.yll_bezwzgledny" class='dateForm indent' />
              </div>
              <div>
                3.2.6. YLL/100 tys. (wsk. surowy)
                <input type="text" v-model="formData.yll_100" class='dateForm indent' />
              </div>
              <div>
                <div>
                3.2.7.  Analiza trendu wskaźnika YLL w latach 1990-2019 
                 <input class="file" type="file" id="filesSecond" :ref="'filesSecond'"  multiple v-on:change="handleFileUploadsFirst('filesSecond')" accept="image/*"/>
                  <button type="button" class="buttonRDTL" @click="addFilesFirst('filesSecond')" >Dodaj załącznik</button>
              <!-- <div v-for="(file, key) in files" :key='key' class="file-listing"> -->
                <span v-if="(formData.yyl_jpg)" class="download padding" @click="getFileFirst('filesSecond')">{{ filename(formData.yyl_jpg) }} </span>
                <span v-if="(formData.yyl_jpg)" class="padding remFile" v-on:click="removeFileFirst('filesSecond')">X</span>

              </div>
                3.2.8. Współczynnik zapadalności (surowy)
                <input type="text" v-model="formData.zapadalnosc" class='dateForm indent' />
              </div>
              <div>
                3.2.9. Współczynnik chorobowości (surowy)
                <input type="text" v-model="formData.chorobowosc" class='dateForm indent' />
              </div>
               <div>
                3.2.10.  Wagi niesprawności 
                 <input class="file" type="file" id="filesThird" :ref="'filesThird'"  multiple v-on:change="handleFileUploadsFirst('filesThird')" accept="image/*"/>
                  <button type="button" class="buttonRDTL" @click="addFilesFirst('filesThird')" >Dodaj załącznik</button>
              <!-- <div v-for="(file, key) in files" :key='key' class="file-listing"> -->
                <span v-if="(formData.tab_jpg)" class="download padding" @click="getFileFirst('filesThird')">{{ filename(formData.tab_jpg) }} </span>
                <span v-if="(formData.tab_jpg)" class="padding remFile" v-on:click="removeFileFirst('filesThird')">X</span>

              </div>
              <div>
                3.2.10. Komentarz <br>
                <textarea class="textareaForm" v-model="formData.komentarz_epi" rows="3"></textarea>
              </div>
            </div>
          </div>
          <div>
            3.3. Opcje alternatywne na podstawie EPAR<br><br>
            <div class='indent'>
                <div>
                  3.3.1. Opis z dokumentów EMA
                  <textarea class="textareaForm" v-model="formData.opis_ema" rows="3"></textarea>
                </div>
                <div>
                  3.3.2. Komparator na podstawie EMA
                  <textarea class="textareaForm" v-model="formData.komparator_ema" rows="3"></textarea>
                </div>
                <div>
                  3.3.3. Komentarz do opcji alternatywnych wg EMA
                  <textarea class="textareaForm" v-model="formData.komentarz_ema" rows="3"></textarea>
                </div>
            </div>
          </div>
          <div>
            3.4. Opcje alternatywne na podstawie wytycznych klinicznych<br><br>
            <div class='indent'>
              <div>
                3.4.1. Wytyczne kliniczne odnoszące się do ocenianego wskazania
                <label class='indent'>
                  <input type="radio" v-model='formData.wytyczne_kli_alt' :value='true'>Tak
                </label>
                <label>
                  <input type="radio"  v-model='formData.wytyczne_kli_alt' :value='false'>Nie
                </label>
                <label>
                  <input type="radio"  v-model='formData.wytyczne_kli_alt' :value='null'>Nie odnaleziono
                </label>
              </div>
              <span v-if='formData.wytyczne_kli_alt'>
                <div class='repeatedPart' v-for='(wytyczna, index) in formData.wytyczna_alter' :key="'wa'+index">
                  <div>
                    WYTYCZNA KLINICZNA {{index+1}} 
                    <span class='tooltip'>
                      <font-awesome-icon icon="minus-square" class='redIcon indent' @click='decreaseWytycz(index, wytyczna.id)'/>
                      <span class='tooltiptext'>usuń wybraną wytyczną</span>
                    </span>
                  </div>
                  <div>
                    3.4.2. Nazwa organizacji, skrót, rok, kraj/zasięg, link <br>
                    <textarea class="textareaForm" v-model="formData.wytyczna_alter[index].nazwa_organizacji_alt" rows="3"></textarea>
                  </div>
                  <!-- <div class='indent'>
                    3.5.2.1. Opis wytycznych <br>
                    <textarea class="textareaForm" v-model="formData.wytyczna_alter[index].opis_wytycznych_alt" rows="3"></textarea>
                  </div> -->
                </div>
                <button type='button' style='float:right;' @click='increaseWytycz()' class="buttonRDTL">dodaj kolejną wytyczną</button><br>
              </span>
              <div>
                3.4.3. Podsumowanie wytycznych <br>
                <textarea class="textareaForm" v-model="formData.podsumowanie_wytyczne" rows="3"></textarea>
              </div>
              <div>
                3.4.4. Komparator na podstawie wytycznych<br>
                <textarea class="textareaForm" v-model="formData.komparator_alt" rows="3"></textarea>
              </div>
              <div>
                3.4.5. Czy wytyczne kliniczne odnoszą się do ocenianej TL
                <label class='indent'>
                  <input type="radio" v-model='formData.odniesienie_tl' :value='true'>Tak
                </label>
                <label>
                  <input type="radio"  v-model='formData.odniesienie_tl' :value='false'>Nie
                </label>
                <label>
                  <input type="radio"  v-model='formData.odniesienie_tl' :value='null'>Nie odnaleziono
                </label>
              </div>
              <div>
                3.4.6. Miejsce ocenianej technologii w wytycznych<br>
                <textarea class="textareaForm" v-model="formData.miejsce_wytyczne" rows="3"></textarea>
              </div>
              <div>
                3.4.7. Komentarz do wytycznych klinicznych<br>
                <textarea class="textareaForm" v-model="formData.komentarz_alt" rows="3"></textarea>
              </div>
            </div>
          </div>
          <div>
            3.5. Opcje alternatywne finansowane<br><br>
            <div class='indent'>
              <div>
                3.5.1. Dostępność finansowanych opcji alternatywnych wg Obwieszczenia MZ
                <label class='indent'>
                  <input type="radio" v-model='formData.dostepnosc_finansowania' :value='true' @input='checkSubst()'>Tak
                </label>
                <label>
                  <input type="radio"  v-model='formData.dostepnosc_finansowania' :value='false'>Nie
                </label>
                <label>
                  <input type="radio"  v-model='formData.dostepnosc_finansowania' :value='null'>Nie określono
                </label>
              </div>
              <span v-if='formData.dostepnosc_finansowania'>
                <div class='repeatedPart' v-for='(substancja, index) in formData.substancja_czynna' :key="'sc'+index">
                  <div>
                    SUBSTANCJA CZYNNA {{index+1}} 
                    <span class='tooltip'>
                      <font-awesome-icon icon="minus-square" class='redIcon indent' @click='decreaseSubst(index, substancja.id)'/>
                      <span class='tooltiptext'>usuń wybraną substancję</span>
                    </span>
                  </div>
                  <div>
                    3.5.2. Nazwa finansowanej substancji czynnej wg Obwieszczenia MZ <br>
                    <textarea class="textareaForm" v-model="formData.substancja_czynna[index].substancje_czynnne_mz" rows="3"></textarea>
                  </div>
                  <div class="indent">
                    3.5.2.1. Sposób finansowania wg Obwieszczenia MZ <br>
                    <textarea class="textareaForm" v-model="formData.substancja_czynna[index].sposob_finansowanie" rows="3"></textarea>
                  </div>
                </div>
                <button type='button' style='float:right;' @click='increaseSubst()' class="buttonRDTL">dodaj kolejną substancję</button><br>
              </span>
              <div>
                3.5.3. Komparator na podstawie opcji finansowanych <br>
                <textarea class="textareaForm" v-model="formData.komparator" rows="3"></textarea>
              </div>
              <div>
                3.5.4. Komentarz do opcji alternatywnych finansowanych<br>
                <textarea class="textareaForm" v-model="formData.komentarz_alter" rows="3"></textarea>
              </div>
            </div>
          </div>
          <div>
            3.6. Podsumowanie oceny niezaspokojonej potrzeby zdrowotnej<br><br>
            <div class="indent">
              3.6.1. Komentarz
              <textarea class="textareaForm" v-model="formData.komentarz_podsumowanie" rows="3"></textarea>
            </div>
          </div>
        </div>
      </div>
      <hr>
      <div>
        <h3 id='paragraph4'>4. Ocena populacji docelowej </h3>
        <div class='indent'>
          <div>
            4.1. Metodyka szacowania populacji
            <textarea class="textareaForm" v-model="formData.metodyka_szacowania_populacji" rows="3"></textarea>
          </div>
          <div>
            4.2. Wielkość populacji docelowej
            <!-- <input type="number" v-model="formData.wielkosc_populacji_docelowej" class='dateForm indent' step='any'/> -->
            <textarea class="textareaForm" v-model="formData.wielkosc_populacji_docelowej" rows="1"></textarea>
          </div>
          <div class="indent">
            4.2.1. Wielkość populacji docelowej - dolna granica
            <!-- <input type="number" v-model="formData.wielkosc_populacji_docelowej_dolna_granica" class='dateForm indent' step='any'/> -->
            <textarea class="textareaForm" v-model="formData.wielkosc_populacji_docelowej_dolna_granica" rows="1"></textarea>
          </div>
          <div class="indent">
            4.2.2. Wielkość populacji docelowej - górna granica
            <!-- <input type="number" v-model="formData.wielkosc_populacji_docelowej_gorna_granica" class='dateForm indent' step='any'/> -->
            <textarea class="textareaForm" v-model="formData.wielkosc_populacji_docelowej_gorna_granica" rows="1"></textarea>
          </div>
          <div>
            4.3. Przyrost populacji w skali roku
            <!-- <input type="number" v-model="formData.przyrost_populacji_w_skali_roku" class='dateForm indent' step='any'/> -->
            <textarea class="textareaForm" v-model="formData.przyrost_populacji_w_skali_roku" rows="1"></textarea>
          </div>
          <div>
            4.4. Źródła danych <br>
            <textarea class="textareaForm" v-model="formData.zrodla_danych" rows="3"></textarea>
          </div>
          <div>
            4.5. Podsumowanie oceny populacji docelowej<br><br>
            <div class='indent'>
              4.5.1. Komentarz <br>
              <textarea class="textareaForm" v-model="formData.komentarz_oceny_populacji" rows="3"></textarea>
            </div>
          </div>
        </div>
      </div>
      <hr>
      <div>
        <h3 id='paragraph5'>
          5. Ocena siły interwencji - {{formData.badanie.length}}
          <span class='tooltip'>
            <font-awesome-icon icon="plus-square" class='greenIcon' @click='increaseBadania(-1)'/>
            <span class='tooltiptext'>dodaj kolejne badanie</span>
          </span>
        </h3>
        <div class='repeatedPart' v-for='(badanie, index) in formData.badanie' :key="'b'+index">
          <div>
            BADANIE {{index+1}} 
            <span class='tooltip'>
              <font-awesome-icon icon="minus-square" class='redIcon indent' @click='decreaseBadania(index, badanie.id)'/>
              <span class='tooltiptext'>usuń wybrane badanie</span>
            </span>
          </div>
          <div>
            5.1. Nazwa badania <br>
            <textarea class="textareaForm" v-model="formData.badanie[index].nazwa" rows="1" ></textarea>
          </div>
          <div class='indent'>
            <div>
              5.1.1 Typ badania <br>
              <textarea class="textareaForm" v-model="formData.badanie[index].typ" rows="1" placeholder='do zdefiniowania lista rozwijana'></textarea>
            </div>
            <div>
              5.1.2. Charakterystyka badania
            </div>
            <div class='indent'>
              <div>
                5.1.2.1. Komparator z badania <br>
                <textarea class="textareaForm" v-model="formData.badanie[index].komparator" rows="1" ></textarea>
              </div>
              <div>
                5.1.2.2. Okres obserwacji <br>
                <textarea class="textareaForm" v-model="formData.badanie[index].okres_obserwacji" rows="1" ></textarea>
              </div>
              <div>
                5.1.2.3. Okres leczenia <br>
                <textarea class="textareaForm" v-model="formData.badanie[index].okres_lecznie" rows="1" ></textarea>
              </div>
              <div>
                5.1.2.4. Liczba pacjentów <br>
                <textarea class="textareaForm" v-model="formData.badanie[index].liczba_pacjentow" rows="1" ></textarea>
              </div>
            </div>
            <div>
              5.1.3. Punkty końcowe<br><br>
              <div class='indent'>
                5.1.3.1. Kategorie punktów końcowych<br><br>
                <div v-for='(category, indpoint) in Object.keys(badanie.punktkoncowy)' :key='indpoint'>
                  <strong>- {{category}}</strong> - {{howManyPoints(badanie.punktkoncowy[category])}}
                  <span class='tooltip'>
                    <font-awesome-icon icon="plus-square" class='greenIcon' @click='increaseEndpoint(index, category)'/>
                    <span class='tooltiptext'>dodaj kolejny punkt końcowy</span>
                  </span>
                  <div class='repeatedPart' style='border-style: dashed;' v-for='(point, ind) in badanie.punktkoncowy[category]' :key="'e'+ind">
                    <div>
                      PUNKT KOŃCOWY {{ind+1}} 
                      <span class='tooltip'>
                        <font-awesome-icon icon="minus-square" class='redIcon indent' @click='decreaseEndpoint(index, ind, point.id, category)'/>
                        <span class='tooltiptext'>usuń wybrany punkt końcowy</span>
                      </span>
                    </div>
                    <div>
                      5.1.3.1.1. Nazwa punktu końcowego <br>
                      <textarea class="textareaForm" v-model="formData.badanie[index].punktkoncowy[category][ind].nazwa" rows="1" ></textarea>
                      <span class='hideShow' v-if='!formData.badanie[index].punktkoncowy[category][ind].view' @click='viewPK(index, category, ind, true)'>
                        <font-awesome-icon icon="angle-down"/> rozwiń...
                      </span>
                      <span class='hideShow' v-else @click='viewPK(index, category, ind, false)'>
                        <font-awesome-icon icon="angle-up"/> schowaj...
                      </span>
                      <!-- <button type='button' style='float:right;' @click='formData.badanie[index].punktkoncowy[category][ind].view = true' class="buttonRDTL" v-if='!formData.badanie[index].punktkoncowy[category][ind].view'>rozwiń...</button>
                      <button type='button' style='float:right;' @click='formData.badanie[index].punktkoncowy[category][ind].view = false' class="buttonRDTL" v-else>schowaj...</button><br> -->
                    </div>
                    <span v-show='point.view'>
                      <div class='indent'>
                        5.1.3.1.1.1. Typ punktu końcowego <br>
                        <model-select 
                            :options="endpointOptions"
                            v-model="formData.badanie[index].punktkoncowy[category][ind].typ_punktu_końcowego"
                            class="searchSelect"
                          ></model-select>
                      </div>
                      <div class='indent'>
                        5.1.3.1.1.2. Wyniki dla punktu końcowego - {{point.parametrstatystyczny.length}}
                        <span class='tooltip'>
                          <font-awesome-icon icon="plus-square" class='greenIcon' @click='increaseParam(index, ind, category)'/>
                          <span class='tooltiptext'>dodaj kolejny parametr</span>
                        </span>
                      </div>
                      <div class='repeatedPart' style='border-style: dotted;' v-for='(param, i) in point.parametrstatystyczny' :key="'p'+i">
                        <div>
                          PARAMETR {{i+1}} 
                          <span class='tooltip'>
                            <font-awesome-icon icon="minus-square" class='redIcon indent' @click='decreaseParam(index, ind, i, param.id, category)'/>
                            <span class='tooltiptext'>usuń wybrany parametr</span>
                          </span>
                        </div>
                        <div>
                          <label>
                            <input type="radio" v-model='formData.badanie[index].punktkoncowy[category][ind].parametrstatystyczny[i].bezwzgledny' 
                              value='wzgledny' @input='formData.badanie[index].punktkoncowy[category][ind].parametrstatystyczny[i].nazwa=""'>Parametr względny
                          </label>
                          <label>
                            <input type="radio" v-model='formData.badanie[index].punktkoncowy[category][ind].parametrstatystyczny[i].bezwzgledny' 
                              value='bezwzględny' @input='formData.badanie[index].punktkoncowy[category][ind].parametrstatystyczny[i].nazwa=""'>Parametr bezwzględny
                          </label>
                          <label>
                            <input type="radio" v-model='formData.badanie[index].punktkoncowy[category][ind].parametrstatystyczny[i].bezwzgledny' 
                              value='inny' @input='formData.badanie[index].punktkoncowy[category][ind].parametrstatystyczny[i].nazwa=""'>Parametr inny
                          </label>
                        </div>
                        <div>
                          <model-select v-if='formData.badanie[index].punktkoncowy[category][ind].parametrstatystyczny[i].bezwzgledny == "bezwzględny"'
                            :options="paramsOptionBezwzgl"
                            v-model="formData.badanie[index].punktkoncowy[category][ind].parametrstatystyczny[i].nazwa"
                            class="searchSelect"
                          ></model-select>
                          <model-select v-else-if='formData.badanie[index].punktkoncowy[category][ind].parametrstatystyczny[i].bezwzgledny == "wzgledny"'
                            :options="paramsOptionWzgl"
                            v-model="formData.badanie[index].punktkoncowy[category][ind].parametrstatystyczny[i].nazwa"
                            class="searchSelect"
                          ></model-select>
                          <textarea class="textareaForm" v-else-if='formData.badanie[index].punktkoncowy[category][ind].parametrstatystyczny[i].bezwzgledny == "inny"' 
                            v-model="formData.badanie[index].punktkoncowy[category][ind].parametrstatystyczny[i].nazwa" rows="1" placeholder="Nazwa parametru"></textarea>
                        </div>
                        <div>
                          Wartość parametru
                          <input type="number" v-model="formData.badanie[index].punktkoncowy[category][ind].parametrstatystyczny[i].wartosc" class='dateForm indent' step='any'/>
                        <!-- </div>
                        <div> --><br>
                          Przedział ufności (95%CI) - dolna granica
                          <input type="number" v-model="formData.badanie[index].punktkoncowy[category][ind].parametrstatystyczny[i].przedzial_dol" class='dateForm indent' step='any'/>
                          <span class='indent'>
                            górna granica
                            <input type="number" v-model="formData.badanie[index].punktkoncowy[category][ind].parametrstatystyczny[i].przedzial_gora" class='dateForm indent' step='any'/>
                          </span>
                        </div>
                        <div>
                          Wartość parametru w ramieniu interwencji
                          <input type="number" v-model="formData.badanie[index].punktkoncowy[category][ind].parametrstatystyczny[i].interwencja_wartosc" class='dateForm indent' step='any'/>
                        <!-- </div>
                        <div> --><br>
                          Przedział ufności (95%CI) - dolna granica
                          <input type="number" v-model="formData.badanie[index].punktkoncowy[category][ind].parametrstatystyczny[i].interwencja_przedzial_dol" class='dateForm indent' step='any'/>
                          <span class='indent'>
                            górna granica
                            <input type="number" v-model="formData.badanie[index].punktkoncowy[category][ind].parametrstatystyczny[i].interwencja_przedzial_gora" class='dateForm indent' step='any'/>
                          </span>
                        </div>
                        <div>
                          Wartość parametru w ramieniu komparatora
                          <input type="number" v-model="formData.badanie[index].punktkoncowy[category][ind].parametrstatystyczny[i].komparator_wartosc" class='dateForm indent' step='any'/>
                        <!-- </div>
                        <div> --><br>
                          Przedział ufności (95%CI) - dolna granica
                          <input type="number" v-model="formData.badanie[index].punktkoncowy[category][ind].parametrstatystyczny[i].komparator_przedzial_dol" class='dateForm indent' step='any'/>
                          <span class='indent'>
                            górna granica
                            <input type="number" v-model="formData.badanie[index].punktkoncowy[category][ind].parametrstatystyczny[i].komparator_przedzial_gora" class='dateForm indent' step='any'/>
                          </span>
                        </div>
                        <div>
                          Wartość p
                          <textarea class="textareaForm" v-model="formData.badanie[index].punktkoncowy[category][ind].parametrstatystyczny[i].wartosc_p" rows="1" ></textarea>
                        </div>
                        <div>
                          Opis
                          <textarea class="textareaForm" v-model="formData.badanie[index].punktkoncowy[category][ind].parametrstatystyczny[i].opis" rows="1" ></textarea>
                        </div>
                      </div>
                      <div class='indent'>
                        5.1.3.1.1.3. Komentarz
                        <textarea class="textareaForm" v-model="formData.badanie[index].punktkoncowy[category][ind].komentarz_punkt_koncowy" rows="3" ></textarea>
                      </div>
                    </span>
                  </div>
                </div> 
              </div>
            </div>
            <div>  
              5.1.4. Wykres Kaplana-Meiera <br>
               <input class="file" type="file" id="files" :ref="'files'+index"  multiple v-on:change="handleFileUploads(index)" accept="image/*"/>
              <button type="button" class="buttonRDTL" @click="addFiles(index)" >Dodaj załącznik</button>
              <!-- <div v-for="(file, key) in files" :key='key' class="file-listing"> -->
                <span v-if="(formData.badanie[index].wykres_kaplana)" class="download padding" @click="getFile(index)">{{ filename(formData.badanie[index].wykres_kaplana) }} </span>
                <span v-if="(formData.badanie[index].wykres_kaplana)" class="padding remFile" v-on:click="removeFile(index)">X</span>
              <!-- </div> -->
              <br><br>
              <div class='indent'>
                5.1.4.1. Komentarz <br>
                <textarea class="textareaForm" v-model="formData.badanie[index].komentarz_wykres" rows="3" ></textarea>
              </div>
            </div>
            <div>
              5.1.5. Wartość LYG <br>
              <div class="indent">
                <div>
                  5.1.5.1. LYG/QUALYG w horyzoncie badania
                  <input type="number" v-model="formData.badanie[index].LYG_QUALYG_w_horyzoncie_badania" class='dateForm indent' step='any'/>
                </div>
                <div>
                  5.1.5.2. LYG/QUALYG w horyzoncie rocznym
                  <input type="number" v-model="formData.badanie[index].LYG_QUALYG_w_horyzoncie_rocznym" class='dateForm indent' step='any'/>
                </div>
                <div>
                  5.1.5.3. LYG/QUALYG w horyzoncie dożywotnim
                  <input type="number" v-model="formData.badanie[index].LYG_QUALYG_w_horyzoncie_dozywotnim" class='dateForm indent' step='any'/>
                </div>
                <div>
                  5.1.5.4. Komentarz
                  <textarea class="textareaForm" v-model="formData.badanie[index].komentarz_lyg" rows="3" ></textarea>
                </div>
              </div>
            </div>
            <div>
              5.1.6. Ograniczenia badania <br><br>
              <div class='indent'>
                5.1.6.1. Opis ograniczeń <br>
                <textarea class="textareaForm" v-model="formData.badanie[index].opis_ograniczen" rows="3" ></textarea>
              </div>
            </div>
            <div>
              5.1.7. Dodatkowe informacje dot. badania<br><br>
              <div class='indent'>
                5.1.7.1. Komentarz <br>
                <textarea class="textareaForm" v-model="formData.badanie[index].komentarz_dodatkowe" rows="3" ></textarea> <!-- **brak modelu** -->
              </div>
            </div>
            <div>
              5.1.8. Ocena jakości badania <br><br>
              <div class='indent'>
                <div>
                  5.1.8.1. Skala oceny
                  <label class='indent'>
                    <input type="radio" v-model='formData.badanie[index].skala' :value='true'>Cochrane
                  </label>
                  <label>
                    <input type="radio"  v-model='formData.badanie[index].skala' :value='false'>NICE
                  </label>
                </div>
                <div v-if='formData.badanie[index].skala'>
                  Ocena ryzyka błędu systematycznego wg Cochrane RoB 2
                  <ul>
                    <li>
                      Randomizacja
                      <label v-for='(option, i) in cochrane' :key='i' :class='!i?"indent":""'>
                        <input type="radio" v-model='formData.badanie[index].randomizacja' :value='option' > {{option}}
                      </label>
                    </li>
                    <li>
                      Ukrycie kodu alokacji
                      <label v-for='(option, i) in cochrane' :key='i' :class='!i?"indent":""'>
                        <input type="radio" v-model='formData.badanie[index].ukrycie_alokacji' :value='option' > {{option}}
                      </label>
                    </li>
                    <li>
                      Zaślepienie badaczy i pacjentów
                      <label v-for='(option, i) in cochrane' :key='i' :class='!i?"indent":""'>
                        <input type="radio" v-model='formData.badanie[index].zaslepienie_badaczy' :value='option' > {{option}}
                      </label>
                    </li>
                    <li>
                      Zaślepienie oceny wyników
                      <label v-for='(option, i) in cochrane' :key='i' :class='!i?"indent":""'>
                        <input type="radio" v-model='formData.badanie[index].zaslepienie_oceny' :value='option' > {{option}}
                      </label>
                    </li>
                    <li>
                      Kompletność danych
                      <label v-for='(option, i) in cochrane' :key='i' :class='!i?"indent":""'>
                        <input type="radio" v-model='formData.badanie[index].kompletnosc_danych' :value='option' > {{option}}
                      </label>
                    </li>
                    <li>
                      Selektywne raportowanie wyników
                      <label v-for='(option, i) in cochrane' :key='i' :class='!i?"indent":""'>
                        <input type="radio" v-model='formData.badanie[index].selektywne_raportowanie' :value='option' > {{option}}
                      </label>
                    </li>
                    <li>
                      Inne czynniki
                      <label v-for='(option, i) in cochrane' :key='i' :class='!i?"indent":""'>
                        <input type="radio" v-model='formData.badanie[index].inne_czynniki' :value='option' > {{option}}
                      </label>
                    </li>
                  </ul>
                </div>
                <div v-else-if='formData.badanie[index].skala===false'>
                  Ocena wg skali NICE
                  <ul class='indent'>
                    <li>
                      Czy badanie było wieloośrodkowe?
                        <label class='indent'>
                          <input type="radio" v-model='formData.badanie[index].wielosrodkowe' :value='true'>Tak
                        </label>
                        <label>
                          <input type="radio"  v-model='formData.badanie[index].wielosrodkowe' :value='false'>Nie
                        </label>
                    </li>
                    <li>
                      Czy cel (hipoteza) badania został jasno określony?
                        <label class='indent'>
                          <input type="radio" v-model='formData.badanie[index].hipoteza' :value='true'>Tak
                        </label>
                        <label>
                          <input type="radio"  v-model='formData.badanie[index].hipoteza' :value='false'>Nie
                        </label>
                    </li>
                    <li>
                      Czy kryteria włączenia i wykluczenia zostały jasno sformułowane?
                        <label class='indent'>
                          <input type="radio" v-model='formData.badanie[index].wylaczenie_wyklucznie' :value='true'>Tak
                        </label>
                        <label>
                          <input type="radio"  v-model='formData.badanie[index].wylaczenie_wyklucznie' :value='false'>Nie
                        </label>
                    </li>
                    <li>
                      Czy podano jasną definicję punktów końcowych?
                        <label class='indent'>
                          <input type="radio" v-model='formData.badanie[index].jasna_def_punktu' :value='true'>Tak
                        </label>
                        <label>
                          <input type="radio"  v-model='formData.badanie[index].jasna_def_punktu' :value='false'>Nie
                        </label>
                    </li>
                    <li>
                      Czy badanie było prospektywne?
                        <label class='indent'>
                          <input type="radio" v-model='formData.badanie[index].prospektywne' :value='true'>Tak
                        </label>
                        <label>
                          <input type="radio"  v-model='formData.badanie[index].prospektywne' :value='false'>Nie
                        </label>
                    </li>
                    <li>
                      Czy stwierdzono, że rekrutacja odbywała się w sposób konsekutywny?
                        <label class='indent'>
                          <input type="radio" v-model='formData.badanie[index].konsekutywny' :value='true'>Tak
                        </label>
                        <label>
                          <input type="radio"  v-model='formData.badanie[index].konsekutywny' :value='false'>Nie
                        </label>
                    </li>
                    <li>
                      Czy jasno przedstawiono najważniejsze wyniki badania?
                        <label class='indent'>
                          <input type="radio" v-model='formData.badanie[index].jasno_przedstawiono_wyniki' :value='true'>Tak
                        </label>
                        <label>
                          <input type="radio"  v-model='formData.badanie[index].jasno_przedstawiono_wyniki' :value='false'>Nie
                        </label>
                    </li>
                    <li>
                      Czy przeprowadzono analizę wyników w podgrupach?
                        <label class='indent'>
                          <input type="radio" v-model='formData.badanie[index].podrupy' :value='true'>Tak
                        </label>
                        <label>
                          <input type="radio"  v-model='formData.badanie[index].podrupy' :value='false'>Nie
                        </label>
                    </li>
                  </ul>
                </div>
                <div>
                  5.1.8.2. Wynik oceny <br>
                  <textarea class="textareaForm" v-model="formData.badanie[index].wynik_oceny" rows="5" placeholder='do ustalenia możliwość automatyczego wyliczenia sumy/ generacji opisu - konieczne ustalenie szablonu'></textarea>
                </div>
              </div>
            </div>
          </div>
          <div>
            5.2. Podsumowanie oceny siły interwencji <br><br>
            <div class='indent'>
              5.2.1. Komentarz <br>
              <textarea class="textareaForm" v-model="formData.badanie[index].podsumowanie_oceny_siły_interwencji" rows="3"></textarea>
            </div>
          </div>
        </div>
        <div class='indent'>
            5.3. Podsumowanie siły interwencji <br>
            <textarea class="textareaForm" v-model="formData.podusmowanie_sily_interencji" rows="3"></textarea>
          </div>
      </div>
      <hr>
      <div>
        <h3  id='paragraph6'>6. Ocena jakości dowodów naukowych</h3>
        <div class='indent'>
          6.1. Podsumowanie oceny jakości dowodów naukowych<br><br>
          <div class='indent'>
            6.1.1. Komentarz <br>
            <textarea class="textareaForm" v-model="formData.podsumowanie_oceny_naukowej" rows="3"></textarea>
          </div>
        </div>
      </div>
      <hr>
      <div>
        <h3 id='paragraph7'>7. Dodatkowe informacje na podstawie ChPL </h3>
        <div class='indent'>
          7.1. Działania niepożądane wg ChPL<br>
          <textarea class="textareaForm" v-model="formData.aes_z_chpl" rows="3"></textarea>
        </div>
      </div>
      <hr>
      <div>
        <h3 id='paragraph8'>8. Ocena kosztów całkowitych </h3>
        <div class='indent'>
          8.1. Założenia <br><br>
          <div class="indent">
            8.1.1. Populacja docelowa <br><br>
            <div class="indent">
              <div>
                8.1.1. Wielkość populacji docelowej w I roku 
                <input type="number" v-model="formData.wielkosc_populacji_1rok" class='dateForm indent' step='any'/>
              </div>
              <div>
                8.1.1.2. Wielkość populacji docelowej w II roku 
                <input type="number" v-model="formData.wielkosc_populacji_2rok" class='dateForm indent' step='any'/>
              </div>
              <div>
                8.1.1.3. Wielkość populacji docelowej w okresie stabilnym 
                <input type="number" v-model="formData.wielkosc_populacji_stabilna" class='dateForm indent' step='any'/>
              </div>
              <div>
                8.1.1.4. Wielkość populacji docelowej w roku (średnia)
                <input type="number" v-model="formData.wielkosc_populacji_srednia" class='dateForm indent' step='any'/>
              </div>
              <div>
                8.1.1.5. Komentarz
                <textarea class="textareaForm" v-model="formData.komentarz_populacji" rows="3"></textarea>
              </div>
            </div>
            8.1.2. Perspektywa <br><br>
            <div class="indent">
              8.1.2.1 Komentarz
              <textarea class="textareaForm" v-model="formData.perspektywa" rows="3"></textarea>
            </div>
            8.1.3. Horyzont czasowy <br><br>
            <div class="indent">
              8.1.2.1 Komentarz
              <textarea class="textareaForm" v-model="formData.horyzont" rows="3"></textarea>
            </div>
            8.1.4. Koszty<br><br>
            <div class="indent">
              <div>
                8.1.4.1. Cena leku
                <input type="number" v-model="formData.cena_leku" class='dateForm indent' step='any'/>
              </div>
              <div class="indent">
                8.1.4.1.1. Dane dot. ceny leku
                <textarea class="textareaForm" v-model="formData.dane_dot_ceny" rows="3" placeholder="podanie informacji czy cena wg EURIPID/CZN,UCZ,CHB; wielkość opakowania; cena za jednostkę (za mg/ml)"></textarea>
              </div>
              <div>
                8.1.4.2. Koszt leku na pacjenta
                <input type="number" v-model="formData.koszt_pacjenta_na_rok" class='dateForm indent' step='any'/>
              </div>
              <div>
                8.1.4.3. Dodatkowe informacje dot. kosztów terapii
                <textarea class="textareaForm" v-model="formData.koszt_informacje" rows="3" placeholder="informacje nt innych leków, badań diagnostycznych uwzględnianych w schemacie leczenia"></textarea>
              </div>
              <div>
                8.1.4.4. Dodatkowe koszty - opcjonalne
                <input type="number" v-model="formData.dodatkowe_koszty" class='dateForm indent' step='any'/>
              </div>
              <div class="indent">
                8.1.4.5. Komentarz
                <textarea class="textareaForm" v-model="formData.koszty_komentarz" rows="3"></textarea>
              </div>
            </div>
          </div>
          8.2. Wyniki oszacowań
          <button type='button' @click='getKosztCalk()' class="buttonRDTL indent">przelicz koszty</button>
          <br><br>
          <div class="indent">
            <div>
              8.2.1. Całkowity koszt leku w I roku 
              <input type="number" id='ck1' v-model="formData.calkowity_koszt_1rok" class='dateForm indent' step='any'/>
            </div>
            <div>
              8.2.2. Całkowity koszt leku w II roku 
              <input type="number" id='ck2' v-model="formData.calkowity_koszt_2rok" class='dateForm indent' step='any'/>
            </div>
            <div>
              8.2.3. Całkowity koszt leku w okresie stabilnym 
              <input type="number" id='ckst' v-model="formData.calkowity_koszt_stabilny" class='dateForm indent' step='any'/>
            </div>
            <div>
              8.2.4. Całkowity średni roczny koszt leku
              <input type="number" id='ckavg' v-model="formData.calkowity_koszt_sredni" class='dateForm indent' step='any'/>
            </div>
          </div>
          8.3. Podsumowanie oceny kosztów całkowitych<br><br>
          <div class='indent'>
            8.3.1. Komentarz <br>
            <textarea class="textareaForm" v-model="formData.komentarz_wplywu_na_budzet" rows="3"></textarea>
          </div>
        </div>
      </div>
      <hr>
      <div>
        <h3 id='paragraph9'>9. Zagraniczne rekomendacje refundacyjne</h3>
        <div class='indent'>
          <div>
            9.1. Wynik wyszukiwania
            <label class='indent'>
              <input type="radio" v-model='formData.wynik_wyszukiwania' :value='true'>Tak
            </label>
            <label>
              <input type="radio"  v-model='formData.wynik_wyszukiwania' :value='false'>Nie
            </label>
            <label>
              <input type="radio"  v-model='formData.wynik_wyszukiwania' :value='null'>Nie określono
            </label>
          </div>
          <div  class='repeatedPart' v-for='(instytucja, index) in formData.instytucja' :key="'inst'+index">
            <div>
              ZAGRANICZNA REKOMENDACJA {{index+1}} 
              <span class='tooltip'>
                <font-awesome-icon icon="minus-square" class='redIcon indent' @click='decreaseInstyt(index, instytucja.id)'/>
                <span class='tooltiptext'>usuń wybraną rekomendację</span>
              </span>
            </div>
            <div>
              9.2. Nazwa instytucji, rok, zasięg/kraj, link<br>
              <textarea class="textareaForm" v-model="formData.instytucja[index].nazwa_instytucji" rows="3"></textarea><br>
            </div>
            <div class='indent'> 
              9.2.1. Wynik oceny
              <div class='indent'>
                <label>
                  <input type="radio"  v-model='formData.instytucja[index].wynik_oceny' value='pos'>pozytywna
                </label><br>
                <label>
                  <input type="radio"  v-model='formData.instytucja[index].wynik_oceny' value='posvar'>pozytywna warunkowa
                </label><br>
                <label>
                  <input type="radio"  v-model='formData.instytucja[index].wynik_oceny' value='neg'>negatywna
                </label><br>
                <label>
                  <input type="radio"  v-model='formData.instytucja[index].wynik_oceny' value='neu'>neutralna
                </label><br>
                <label>
                  <input type="radio"  v-model='formData.instytucja[index].wynik_oceny' value='in'>w trakcie
                </label><br>
                <label>
                  <input type="radio"  v-model='formData.instytucja[index].wynik_oceny' value='out'>odstąpiono od oceny
                </label>
              </div>
            </div>
            <div class='indent'>
              9.2.2. Uzasadnienie oceny <br>
              <textarea class="textareaForm" v-model="formData.instytucja[index].uzasadnienie_oceny" rows="3"></textarea>
            </div>
          </div>
          <button type='button' style='float:right;' @click='increaseInstyt()' class="buttonRDTL">dodaj kolejną rekomendację</button><br>
        </div>
      </div>
      <hr>
      <div>
        <h3 id='paragraph10'>10. Ocena niepewności wnioskowania</h3>
        <div class='indent'>
          10.1. Komentarz<br>
          <textarea class="textareaForm" v-model="formData.ocena_niepewnosci" rows="3"></textarea>
        </div>
      </div>
      <hr>
      <div>
        <h3 id='paragraph11'>11. Dodatkowe informacje</h3>
        <div class='indent'>
          11.1. Komentarz<br>
          <textarea class="textareaForm" v-model="formData.dodatkowe_inofrmacje" rows="3"></textarea>
        </div>
      </div>
      <hr>
      <div>
        <h3 id='paragraph12'>12. Źródła danych(linki)/Bibliografia</h3>
        <div class="indent">
          <div>
            12.1. Strona EMA<br>
            <textarea class="textareaForm" v-model="formData.chpl" rows="1" placeholder="link"></textarea>
          </div>
          <!-- <div>
            12.2. EPAR<br>
            <textarea class="textareaForm" v-model="formData.epar" rows="1" placeholder="link"></textarea>
          </div> -->
          <div>
            12.2. Badanie rejestracyjne
            <span class='tooltip'>
                <font-awesome-icon icon="plus-square" class='greenIcon indent' @click='formData.badania_rejestracyjne.push("")'/>
                <span class='tooltiptext'>dodaj kolejne badanie rejestracyjne</span>
              </span><br>
            <span v-for='(badRej, index) in formData.badania_rejestracyjne' :key='"br"+index' class='twoGrid'>
              <textarea class="textareaForm" v-model="formData.badania_rejestracyjne[index]" rows="1" placeholder="link"></textarea>
              <span class='tooltip'>
                <font-awesome-icon icon="minus-square" class='redIcon indent' @click='formData.badania_rejestracyjne.splice(index, 1)'/>
                <span class='tooltiptext' v-if='false'>usuń wybrane badanie rejestracyjne</span>
              </span>
            </span>
          </div>
        </div>
      </div>
      <hr id='bottom'>
      <div style='float: right;'>
        <button v-if='editedId' type="button" @click.once="edit()" class='buttonRDTL' style='font-size: 18px;'>Zapisz zmiany</button>
        <button v-else type="button" @click.once="send()" class='buttonRDTL' style='font-size: 18px;'>Prześlij</button>
        <button type="button" @click="$router.push('/')" class='buttonRDTL' style='font-size: 18px;'>Anuluj</button>
      </div>

    </div>

    <modal name="deleteWarn" styles="padding: 40px;" :width='450' :height='150' >
        <div style='text-align:center'>
            <div>
                Czy na pewno chcesz usunąć {{'wybran'+deleteIndex.char}}
                <strong>{{deleteIndex.item}}</strong>?<br><br>
            </div>
            <span>
              <button type="button" @click="deleteItem(deleteIndex.item)" class='buttonRDTL'>Tak</button>
              <button type="button" @click="$modal.hide('deleteWarn')" class='buttonRDTL'>Anuluj</button>
            </span>
        </div>
    </modal>

    <template id="sidebar">
        <div class="sidebar">
            <transition name="slide">
            <div v-if="isNavOpen" class="sidebar-panel">
                <ul class="sidebar-panel-nav">
                  <li @click='scroll("paragraph1")'>1. Produkt leczniczy</li>
                  <li @click='scroll("paragraph2")'>2. Status leku</li>
                  <li @click='scroll("paragraph3")'>3. Ocena niezaspokojonej potrzeby zdrowotnej</li>
                  <li @click='scroll("paragraph4")'>4. Ocena populacji docelowej</li>
                  <li @click='scroll("paragraph5")'>5. Ocena siły interwencji</li>
                  <li @click='scroll("paragraph6")'>6. Ocena jakości dowodów naukowych</li>
                  <li @click='scroll("paragraph7")'>7. Dodatkowe informacje na podstawie ChPL</li>
                  <li @click='scroll("paragraph8")'>8. Ocena kosztów całkowitych</li>
                  <li @click='scroll("paragraph9")'>9. Zagraniczne rekomendacje refundacyjne</li>
                  <li @click='scroll("paragraph10")'>10. Ocena niepewności wnioskowania</li>
                  <li @click='scroll("paragraph11")'>11. Dodatkowe informacje</li>
                  <li @click='scroll("paragraph12")'>12. Źródła danych(linki) /Bibliografia</li>
                </ul>
                <div class='sidebar-tag' style="height:80px;" @click="isNavOpen=!isNavOpen">
                        <div>Schowaj</div>
                </div>
            </div>
            <div v-if="!isNavOpen" class="sidebar-panel" style="width:5px; padding-right:0px;  padding-left:0px;  " @click="isNavOpen=!isNavOpen">
                <div class='sidebar-tag' style="height:100px;">
                        <div>Spis&nbsp;treści</div>
                </div>
            </div>
            </transition>
        </div>
    </template>

  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import moment from "moment";
import router from "../router.js";
import Vue from 'vue'

export default {
  name:'formDrug',
  data() {
    return {
      isNavOpen:false,
      formData:{
        "badanie": [],
        "substancja_czynna": [],
        "instytucja": [],
        "wytyczna_alter": [],
        "badania_rejestracyjne": [],
        'daly_jpg':'',
        'yyl_jpg':'',
        'tab_jpg':""
      },
      cochrane:['niskie','umiarkowane','wysokie','niejasne'],
      paramsOptionWzgl: [
        { value: 'HR', text: "HR " },
        { value: 'OR', text: "OR " },
        { value: 'RR', text: "RR " },
      ],
      paramsOptionBezwzgl: [
        { value: 'ARR', text: "ARR " },
        { value: 'RB', text: "RB " },
        { value: 'RK', text: "RK " },
      ],
      czasLeczeniaOptions:[
        { value: 'tcia', text: "terapia ciągła" },
        { value: 'tjed', text: "terapia jednorazowa" },
        { value: 'inny', text: "inny " },
      ],
      endpointOptions:[
        {value: 'pierwszorzędowy', text: "Pierwszorzędowy"},
        {value: 'drugorzędowy', text: "Drugorzędowy"},
        {value: 'inny', text: "Inny"},
      ],
      wiekOptions:[
        { value: 'dzieci', text: "dzieci " },
        { value: 'dorośli', text: "dorośli " },
        { value: 'dorośli i dzieci', text: "dorośli i dzieci " },
      ],
      disqualificationOptions:[
        { value: 'Rejestracja przed 01.01.2017', text: "Rejestracja przed 01.01.2017 " },
        { value: 'Status TLI', text: "Status TLI " },
        { value: 'Finansowanie w Polsce', text: "Finansowanie w Polsce " },
        { value: 'Oceniany w Agencji', text: "Oceniany w Agencji " },
        { value: 'Inne', text: "Inne " },
      ],
      deleteIndex:{badanie:-1, punkt: -1, param: -1, item: '', char:''},
      deletedBadania: [],
      deletedPunkty: [],
      deletedParams: [],
      deletedSubst: [],
      deletedInstyt: [],
      deletedWytycz: [],
      timeout: null,
      editedId: 0,
      filesid: [],
      FileLoad: null,
      files: [],
      filesid1: [],
      FileLoad1: null,
      files1: [],
      categories: ['Wyleczenie', 'Przeżycie', 'Jakość życia','Punkty końcowe zastępcze / surogaty', 'Punkty końcowe związane z bezpieczeństwem'],
    };
  },
  computed: {
    ...mapState({
      entry: (state) => state.entry.entry,
      CurrentUser: state => state.CurrentUser.CurrentUser,
    })
  },
  watch: {},
  methods: {  
    ...mapActions('entry', ['getSingleEntry', 
      'postEntry', 'postBadanie', 'postPunkt', 'postParametr', 'postSubstancja', 'postInstytucja', 'postWytyczna',
      'editEntry', 'editBadanie', 'editPunkt', 'editParametr', 'editSubstancja', 'editInstytucja', 'editWytyczna',
      'deleteBadanie', 'deletePunkt', 'deleteParametr', 'deleteSubstancja', 'deleteInstytucja', 'deleteWytyczna']),
    ...mapActions("edytowane", ["postEdytowane", "deleteEdytowane"]),
    scroll(id){
      document.getElementById(id).scrollIntoView();
    },
    howManyPoints(array){
      if(array) return array.length
      return 0
    },
    viewPK(index, category, ind, flag){
      this.formData.badanie[index].punktkoncowy[category][ind].view = flag
      this.$forceUpdate()
    },
    getKosztCalk(){
      let koszt = this.formData.koszt_pacjenta_na_rok
      let data = this.formData
      data.calkowity_koszt_1rok = Number(koszt * this.formData.wielkosc_populacji_1rok)
      // document.getElementById("ck1").value =  data.calkowity_koszt_1rok
      data.calkowity_koszt_2rok = Number(koszt * this.formData.wielkosc_populacji_2rok)
      // document.getElementById("ck2").value =  data.calkowity_koszt_2rok
      data.calkowity_koszt_stabilny = Number(koszt * this.formData.wielkosc_populacji_stabilna)
      // document.getElementById("ckst").value =  data.calkowity_koszt_stabilny
      data.calkowity_koszt_sredni = Number(koszt * this.formData.wielkosc_populacji_srednia)
      // document.getElementById("ckavg").value =  data.calkowity_koszt_sredni
      this.formData = data 
      this.$forceUpdate()
    },
    changeRejestracja2017(){
      if(!this.formData.data_dopuszczenia){ this.formData.rejestracja2017 = null}else{
        this.formData.rejestracja2017 = moment('2017-01-01').isBefore(moment(this.formData.data_dopuszczenia))
      }
    },
    increaseBadania(){
      let badanie = { //konieczne, by działał v-model
                "nazwa": "",
                "typ": "",
                "komparator": "",
                "okres_obserwacji":"",
                "okres_lecznie":"",
                "liczba_pacjentow":"",
                "wykres_kaplana":"",
                "komentarz_wykres":"",
                "LYG_QUALYG_w_horyzoncie_badania":null,
                "LYG_QUALYG_w_horyzoncie_rocznym":null,
                "LYG_QUALYG_w_horyzoncie_dozywotnim":null,
                "komentarz_lyg":"",
                "opis_ograniczen":"",
                "komentarz_dodatkowe":"",
                "skala": null,
                "randomizacja":"",
                "ukrycie_alokacji":"",
                "zaslepienie_badaczy":"",
                "zaslepienie_oceny":"",
                "kompletnosc_danych":"",
                "selektywne_raportowanie":"",
                "inne_czynniki":"",
                "wielosrodkowe":"",
                "hipoteza":"",
                "wylaczenie_wyklucznie":"",
                "jasna_def_punktu":"",
                "prospektywne":"",
                "konsekutywny":"",
                "jasno_przedstawiono_wyniki":"",
                "podrupy":"",
                "wynik_oceny":"",
                "podsumowanie_oceny_siły_interwencji":"",
                "punktkoncowy": {
                  'Wyleczenie':[], 'Przeżycie':[], 'Jakość życia': [], 
                  'Punkty końcowe zastępcze / surogaty': [], 'Punkty końcowe związane z bezpieczeństwem': []
                },
            }
      this.formData.badanie.push(badanie)
    },
    decreaseBadania(indBadania, id){
      this.deleteIndex = {badanie: indBadania, punkt: -1, param: -1, item: 'badanie', char:'e'}
      if(id) this.deleteIndex['id'] = id
      this.$modal.show('deleteWarn')
    },
    increaseEndpoint(indBadania, category, defVal = {"nazwa": "",
              "typ_punktu_końcowego": "",
              "kategoria": category,
              "parametrstatystyczny":[],
              "komentarz_punkt_koncowy":""}){
      let endpoint = defVal
      endpoint["view"] = false
      this.formData.badanie[indBadania].punktkoncowy[category].push(endpoint)
    },
    decreaseEndpoint(indBadania, indPunktu, id, category){
      this.deleteIndex = {badanie: indBadania, punkt: indPunktu, param: -1, item: 'punkt', char:'y', "category": category}
      if(id) this.deleteIndex['id'] = id
      this.$modal.show('deleteWarn')
    },
    increaseParam(indBadania, indPunktu, category){
      let param = {
        'nazwa':'',
        'wartosc': null,
        'przedzial_dol': null,
        'przedzial_gora':null,
        'interwencja_wartosc':null,
        'interwencja_przedzial_dol':null,
        'interwencja_przedzial_gora':null,
        'komparator_wartosc':null,
        'komparator_przedzial_dol':null,
        'komparator_przedzial_gora':null,
        'wartosc_p': null,
        'bezwzgledny': null,
        "opis": null
      }
      this.formData.badanie[indBadania].punktkoncowy[category][indPunktu].parametrstatystyczny.push(param)
    },
    decreaseParam(indBadania, indPunktu, indParam, id, category){
      this.deleteIndex = {badanie: indBadania, punkt: indPunktu, param: indParam, item: 'parametr', char: 'y', "category": category}
      if(id) this.deleteIndex['id'] = id
      this.$modal.show('deleteWarn')
    },
    increaseSubst(){
      let substancja = { //konieczne, by działał v-model
        "substancje_czynnne_mz": "",
        "sposob_finansowanie": ""
      }
      this.formData.substancja_czynna.push(substancja)
    },
    decreaseSubst(index, id){
      this.deleteIndex = {badanie: index, punkt: -1, param: -1, item: 'substancję czynną', char:'ą'}
      if(id) this.deleteIndex['id'] = id
      this.$modal.show('deleteWarn')
    },
    checkSubst(){
      if(!this.formData.substancja_czynna.length) this.increaseSubst()
    },
    increaseInstyt(){
      let instytucja = { //konieczne, by działał v-model
        "nazwa_instytucji": "",
        "wynik_oceny": "",
        "uzasadnienie_oceny": "",
      }
      this.formData.instytucja.push(instytucja)
    },
    decreaseInstyt(index, id){
      this.deleteIndex = {badanie: index, punkt: -1, param: -1, item: 'zagraniczną rekomendację', char:'ą'}
      if(id) this.deleteIndex['id'] = id
      this.$modal.show('deleteWarn')
    },
    increaseWytycz(){
      let wytyczna = { //konieczne, by działał v-model
        "nazwa_organizacji_alt":"",
        // "opis_wytycznych_alt": ""
      }
      this.formData.wytyczna_alter.push(wytyczna)
    },
    decreaseWytycz(index, id){
      this.deleteIndex = {badanie: index, punkt: -1, param: -1, item: 'wytyczną kliniczną', char:'ą'}
      if(id) this.deleteIndex['id'] = id
      this.$modal.show('deleteWarn')
    },
    deleteItem(item){
      let category = this.deleteIndex.category
      switch(item){
        case 'badanie':
          this.formData.badanie.splice(this.deleteIndex.badanie,1)
          if(this.deleteIndex.id) this.deletedBadania.push(this.deleteIndex.id)
          break;
        case 'punkt':
          this.formData.badanie[this.deleteIndex.badanie].punktkoncowy[category].splice(this.deleteIndex.punkt,1)
          if(this.deleteIndex.id) this.deletedPunkty.push(this.deleteIndex.id)
          break;
        case 'parametr':
          this.formData.badanie[this.deleteIndex.badanie].punktkoncowy[category][this.deleteIndex.punkt].parametrstatystyczny.splice(this.deleteIndex.param,1)
          if(this.deleteIndex.id) this.deletedParams.push(this.deleteIndex.id)
          break;
        case 'substancję czynną':
          this.formData.substancja_czynna.splice(this.deleteIndex.badanie, 1)
          if(this.deleteIndex.id) this.deletedSubst.push(this.deleteIndex.id)
          break;
        case 'zagraniczną rekomendację':
          this.formData.instytucja.splice(this.deleteIndex.badanie, 1)
          if(this.deleteIndex.id) this.deletedInstyt.push(this.deleteIndex.id)
          break;
        case 'wytyczną kliniczną':
          this.formData.wytyczna_alter.splice(this.deleteIndex.badanie, 1)
          if(this.deleteIndex.id) this.deletedWytycz.push(this.deleteIndex.id)
          break;
        default:
          alert('Błąd')
      }
      this.$modal.hide('deleteWarn')
      this.deleteIndex = {badanie:-1, punkt: -1, param: -1, item: '', char: '', category: ''}
    },
    send(){
      let tempBadanie = Object.assign([],this.formData.badanie)
      let tempSubst = this.formData.substancja_czynna
      let tempInstyt = this.formData.instytucja
      let tempWytycz = this.formData.wytyczna_alter
      let dataToSend = Object.assign({},this.formData)
      if (dataToSend.szczegolowa_selekcja !== false) dataToSend.przyczyna_dyskwalifikacji = null
      let file
      delete dataToSend['badanie']
      delete dataToSend['substancja_czynna']
      delete dataToSend['instytucja']
      delete dataToSend['wytyczna_alter']

      Object.keys(dataToSend).forEach(key=>{
        if(dataToSend[key]==="") dataToSend[key]=null
      })

      tempBadanie.forEach((badanie, index)=>{
       this.categories.forEach(cat=>{
        badanie.punktkoncowy[cat].forEach((punkt, ind)=>{
          punkt.parametrstatystyczny.forEach(parametry=>{
              Object.keys(parametry).forEach(key=>{
                if(parametry[key]==="") parametry[key]=null
              })
          })
          delete tempBadanie[index]['punktkoncowy'][cat][ind]['view']
        })
      })})
      let formDataMain = new FormData();
      // formDataMain.append('dane', new Blob([JSON.stringify(dataToSend)], {type: 'applcation/json'}))
      var file1 
      file1 = dataToSend.daly_jpg
      delete dataToSend.daly_jpg
      console.log('file1'+file1)
      if(file1) formDataMain.append('daly_jpg',file1)
      var file2 
      file2 = dataToSend.yyl_jpg
      delete dataToSend.yyl_jpg
       if(file2)  formDataMain.append('yyl_jpg',file2)
      var file3
        file3 = dataToSend.tab_jpg
      delete dataToSend.tab_jpg
     if(file3) formDataMain.append('tab_jpg',file3)
      formDataMain.append('dane', new Blob([JSON.stringify(dataToSend)], {type: 'applcation/json'}))
      this.postEntry(formDataMain).then(response => {
        if(response){
          tempBadanie.forEach((badanie, index) => {
            dataToSend = Object.assign({},badanie)
            delete dataToSend['punktkoncowy']
            dataToSend['przedmiot_analizy'] = response.data.id

            file = dataToSend.wykres_kaplana
            delete dataToSend['wykres_kaplana']
            let formData = new FormData();
            formData.append("dane", new Blob([JSON.stringify(dataToSend)], {type: 'applcation/json'}))
            formData.append("file", file)

            this.postBadanie(formData).then(response =>{
              if(response){
                Object.keys(tempBadanie[index].punktkoncowy).forEach(cat => tempBadanie[index].punktkoncowy[cat].forEach((punkt, ind) =>{
                  dataToSend = Object.assign({},punkt)
                  delete dataToSend['parametrstatystyczny']
                  dataToSend['badanie'] = response.data.id
                  this.postPunkt(dataToSend).then(response => {
                    if(response){
                      tempBadanie[index].punktkoncowy[cat][ind].parametrstatystyczny.forEach((parametr, i) => {
                        dataToSend = Object.assign({},parametr)
                        dataToSend['punkt_koncowy'] = response.data.id
                        this.postParametr(dataToSend)
                      })
                    }
                  })
                }))
              }
            })
          })

          tempSubst.forEach(subst =>{
            dataToSend = Object.assign({},subst)
            dataToSend['przedmiot_analizy'] = response.data.id
            this.postSubstancja(dataToSend)
          })

          tempInstyt.forEach(instyt =>{
            dataToSend = Object.assign({},instyt)
            dataToSend['przedmiot_analizy'] = response.data.id
            this.postInstytucja(dataToSend)
          })

          tempWytycz.forEach(wytycz =>{
            dataToSend = Object.assign({}, wytycz)
            dataToSend['wytyczna_alter'] = response.data.id
            this.postWytyczna(dataToSend)
          })
        }
      })
      clearTimeout(this.timeout);
                this.timeout = setTimeout(() => {
                    this.$router.push('/')
                }, 1000);
    },
    edit(){
      let tempBadanie = Object.assign([], this.formData.badanie)
      let tempSubst = this.formData.substancja_czynna
      let tempInstyt = this.formData.instytucja
      let tempWytycz = this.formData.wytyczna_alter

      let dataToSend = Object.assign({},this.formData)
      if (dataToSend.szczegolowa_selekcja !== false) dataToSend.przyczyna_dyskwalifikacji = null
      let file
      delete dataToSend['badanie']
      delete dataToSend['substancja_czynna']
      delete dataToSend['instytucja']
      delete dataToSend['wytyczna_alter']

      Object.keys(dataToSend).forEach(key=>{
        if(dataToSend[key]==="") dataToSend[key]=null
      })

      tempBadanie.forEach((badanie, index)=>{
       this.categories.forEach(cat=>{
        badanie.punktkoncowy[cat].forEach((punkt, ind)=>{
          punkt.parametrstatystyczny.forEach(parametry=>{
              Object.keys(parametry).forEach(key=>{
                if(parametry[key]==="") parametry[key]=null
              })
          })
          delete tempBadanie[index]['punktkoncowy'][cat][ind]['view']
        })
      })})
      var formDataMain = new FormData()
      var file1 
      file1 = dataToSend.daly_jpg
      delete dataToSend.daly_jpg
      // formDataMain.append('daly_jpg',file1)
      if(file1){
            if (!(typeof(file1.files)=='string' && (file1.files.includes('http://') || file1.files.includes('https://')))){
            formDataMain.append('daly_jpg',file1)
            }}

      var file2 
      file2 = dataToSend.yyl_jpg
      delete dataToSend.yyl_jpg
      // console.log(file2)
      // formDataMain.append('yyl_jpg',file2)
      console.log('wdit file2'+(file2))
      if(file2){
            if (!(typeof(file2.files)=='string' && (file2.files.includes('http://') || file2.files.includes('https://')))){
            formDataMain.append('yyl_jpg',file2)
            }}
      // if(file2 == ''){formDataMain.append('yyl_jpg','')}


      var file3
      file3 = dataToSend.tab_jpg
      delete dataToSend.tab_jpg
      // formDataMain.append('tab_jpg',file3)
      console.log(file3)
      if(file3){
            if (!(typeof(file3.files)=='string' && (file3.files.includes('http://') || file3.files.includes('https://')))){
            formDataMain.append('tab_jpg',file3)
            }}

      
      formDataMain.append('dane', new Blob([JSON.stringify(dataToSend)], {type: 'applcation/json'}))
      this.editEntry([this.editedId, formDataMain]).then(response => {
        if(response){
          tempBadanie.forEach((badanie, index) => {
            dataToSend = Object.assign({},badanie)
            delete dataToSend['punktkoncowy']
            dataToSend['przedmiot_analizy'] = response.id

            file = dataToSend.wykres_kaplana
            delete dataToSend['wykres_kaplana']

            let formData = new FormData();
            formData.append("dane", new Blob([JSON.stringify(dataToSend)], {type: 'applcation/json'}))
            // console.log(file.files)
            // console.log(typeof file.files)
            if(file){
            if (!(typeof(file.files)=='string' && (file.files.includes('http://') || file.files.includes('https://')))){
              // console.log('nie zmiena')
              formData.append("file", file)
            }
                }
            if(badanie.id){
              if(!this.deletedBadania.includes(badanie.id)){
                // console.log("put na badanie")
                this.editBadanie([badanie.id, formData]).then(response =>{
                  if(response){
                  // console.log("response po pucie na badanie"+ response)

                    Object.keys(tempBadanie[index].punktkoncowy).forEach(cat => tempBadanie[index].punktkoncowy[cat].forEach((punkt, ind) =>{
                      dataToSend = Object.assign({},punkt)
                      delete dataToSend['parametrstatystyczny']
                      dataToSend['badanie'] = response.data.id
                      if(punkt.id){
                        if(!this.deletedPunkty.includes(punkt.id)){
                          this.editPunkt([punkt.id, dataToSend]).then(response => {
                            if(response){
                              tempBadanie[index].punktkoncowy[cat][ind].parametrstatystyczny.forEach((parametr, i) => {
                                dataToSend = Object.assign({},parametr)
                                dataToSend['punkt_koncowy'] = response.data.id
                                if(parametr.id){
                                  if(!this.deletedParams.includes(parametr.id)){
                                    this.editParametr([parametr.id, dataToSend])
                                  }
                                }else{
                                  this.postParametr(dataToSend)
                                }
                              })
                            }
                          })
                        }
                      }else{
                        this.postPunkt(dataToSend).then(response => {
                          if(response){
                            tempBadanie[index].punktkoncowy[cat][ind].parametrstatystyczny.forEach((parametr, i) => {
                              dataToSend = Object.assign({},parametr)
                              dataToSend['punkt_koncowy'] = response.data.id
                              this.postParametr(dataToSend).then(response =>{
                                if(response){ this.$router.push('/')}
                              })
                            })
                          }
                        })
                      }
                    }))
                  }
                })
              }
            }else{
              this.postBadanie(formData).then(response =>{
                if(response){
                  Object.keys(tempBadanie[index].punktkoncowy).forEach(cat => tempBadanie[index].punktkoncowy[cat].forEach((punkt, ind) =>{
                    dataToSend = Object.assign({},punkt)
                    delete dataToSend['parametrstatystyczny']
                    dataToSend['badanie'] = response.data.id
                    this.postPunkt(dataToSend).then(response => {
                      if(response){
                        tempBadanie[index].punktkoncowy[cat][ind].parametrstatystyczny.forEach((parametr, i) => {
                          dataToSend = Object.assign({},parametr)
                          dataToSend['punkt_koncowy'] = response.data.id
                          this.postParametr(dataToSend).then(response =>{
                            if(response){ this.$router.push('/')}
                          })
                        })
                      }
                    })
                  }))
                }
              })
            }
          })
        
          tempSubst.forEach((subst) => {
            if(subst.id){
              if(!this.deletedSubst.includes(subst.id)){
                this.editSubstancja([subst.id, subst])
              }
            }else{
              dataToSend = Object.assign({},subst)
              dataToSend['przedmiot_analizy'] = response.id
              this.postSubstancja(dataToSend)
            }
          })

          tempInstyt.forEach((instyt) => {
            if(instyt.id){
              if(!this.deletedInstyt.includes(instyt.id)){
                this.editInstytucja([instyt.id, instyt])
              }
            }else{
              dataToSend = Object.assign({},instyt)
              dataToSend['przedmiot_analizy'] = response.id
              this.postInstytucja(dataToSend)
            }
          })

          tempWytycz.forEach(wytycz =>{
            if(wytycz.id){
              if(!this.deletedWytycz.includes(wytycz.id)){
                this.editWytyczna([wytycz.id, wytycz])
              }
            }else{
              dataToSend = Object.assign({}, wytycz)
              dataToSend['wytyczna_alter'] = response.id
              this.postWytyczna(dataToSend)
            }
          })

        }
      })

      this.deletedParams.forEach(id => {
        this.deleteParametr(id)
      })
      this.deletedPunkty.forEach(id => {
        this.deletePunkt(id)
      })
      this.deletedBadania.forEach(id => {
        this.deleteBadanie(id)
      })
      this.deletedSubst.forEach(id => {
        this.deleteSubstancja(id)
      })
      this.deletedInstyt.forEach(id => {
        this.deleteInstytucja(id)
      })
      this.deletedWytycz.forEach(id => {
        this.deleteWytyczna(id)
      })

      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
          this.$router.push('/')
      }, 1000);
    },
    getDefValues(){
      this.formData = Object.assign({}, this.entry)
      if(this.formData.daly_jpg)this.formData.daly_jpg ={files: this.formData.daly_jpg}
      if(this.formData.yyl_jpg)this.formData.yyl_jpg ={files: this.formData.yyl_jpg}
      if(this.formData.tab_jpg)this.formData.tab_jpg ={files: this.formData.tab_jpg}
      let temp = {}
      this.formData.badanie.forEach((el, i)=>{
        if (el.wykres_kaplana){
          this.formData.badanie[i].wykres_kaplana = {'files':el.wykres_kaplana}
        }
        temp = Object.assign({}, el.punktkoncowy)
        this.formData.badanie[i].punktkoncowy=Object.assign({}, {
                  'Wyleczenie':[], 'Przeżycie':[], 'Jakość życia': [], 
                  'Punkty końcowe zastępcze / surogaty': [], 'Punkty końcowe związane z bezpieczeństwem': []
                })
        // this.categories.forEach(cat => {
        //   if (el.punktkoncowy[cat]) {
        //     temp[cat] = el.punktkoncowy[cat]
        //     temp[cat].forEach((pk, ind)=>{
        //       temp[cat][ind]['view']=false
        //     })
        //   }
        //   else temp[cat] = []
        // })
        // this.formData.badanie[i].punktkoncowy = temp
        // temp = {}
        this.categories.forEach(cat=>{
          if(temp[cat]){
            temp[cat].forEach(pk=>{
              this.increaseEndpoint(i, cat, pk)
            })
          }
        })
      })
        if(this.formData.badanie === null) this.formData.badanie = []
        if(this.formData.substancja_czynna === null) this.formData.substancja_czynna = []
        if(this.formData.instytucja === null) this.formData.instytucja = []
        if(this.formData.wytyczna_alter === null) this.formData.wytyczna_alter = []
        if(this.formData.badania_rejestracyjne === null) this.formData.badania_rejestracyjne = []
    },
    handleFileUploads(index) {
        // console.log(this.$refs['files'+index][0])
        let uploadedFiles = this.$refs['files'+index][0].files;
        // let uploadedFiles = document.getElementById("files")
        // console.log(this.$refs['files'+index][0])

        for (var i = 0; i < uploadedFiles.length; i++) {
          // this.files.push(uploadedFiles[i]);
          this.formData.badanie[index].wykres_kaplana=uploadedFiles[0]
        }
        // console.log("co jest w format" +this.formData.badanie[index].wykres_kaplana)
      },
    addFiles(index) {
      // document.getElementById("files").click()
      this.$refs['files'+index][0].click();
      
    },

    removeFile(index) {
      // if (this.files[key].id) {
      //   this.filesid.push(this.files[key].id)
      // }
      //delete this.files[key]
      // this.files.splice(key, 1);
      this.formData.badanie[index].wykres_kaplana =''

    },
    getFile(index) {
      let fileURL = null
      if (!this.formData.badanie[index].wykres_kaplana.files) { fileURL = window.URL.createObjectURL(this.formData.badanie[index].wykres_kaplana) }
      else {
        fileURL = this.formData.badanie[index].wykres_kaplana.files
      }
      // console.log(fileURL)
      window.open(fileURL, '_blank');
    },
    handleFileUploadsFirst(index) {
        let uploadedFiles = this.$refs[index].files;
         if(index == 'filesFirst'){this.formData.daly_jpg=uploadedFiles[0]} 
         if(index == 'filesSecond'){this.formData.yyl_jpg=uploadedFiles[0]}
         if(index == 'filesThird'){this.formData.tab_jpg=uploadedFiles[0]}
         console.log("z danych"+ (this.formData.yyl_jpg))
          // console.log(this.formData.daly_jpg)
        // for (var i = 0; i < uploadedFiles.length; i++) {
        //   this.formData.daly_jpg=uploadedFiles
        // }
      },
    addFilesFirst(index) {
      this.$refs[index].click();
    },
    getFileFirst(index) {
      
      let fileURL = null
      if(index == 'filesSecond'){
        if (!this.formData.yyl_jpg.files) { fileURL = window.URL.createObjectURL(this.formData.yyl_jpg) }
      else {fileURL = this.formData.yyl_jpg.files}
      }
      if(index == 'filesFirst'){
      if (!this.formData.daly_jpg.files) { fileURL = window.URL.createObjectURL(this.formData.daly_jpg) }
      else {fileURL = this.formData.daly_jpg.files}
      }
      if(index == 'filesThird'){
      if (!this.formData.tab_jpg.files) { fileURL = window.URL.createObjectURL(this.formData.tab_jpg) }
      else {fileURL = this.formData.tab_jpg.files}
      }
      // console.log(fileURL)
      window.open(fileURL, '_blank');
    },
     removeFileFirst(index) {
      if(index == 'filesFirst'){this.formData.daly_jpg =''}
      if(index == 'filesSecond'){this.formData.yyl_jpg =''}
      if(index == 'filesThird'){this.formData.tab_jpg =''}
      

    },
    filename(file) {
      // console.log(file)
        if (file.name) return file.name
        if(file.files) return file.files.split('/')[file.files.split('/').length-1]
        return 'brak pliku'
      },

  },
  created() {
    if(this.$editId){ 
      this.editedId = this.$editId
      let params = {id: this.editedId}
      this.getSingleEntry(params).then(response=>{
        if(response) this.getDefValues()
      })
      params = {Uid: this.CurrentUser[0].id, id_wpis: this.editedId}
      this.postEdytowane(params)
      window.addEventListener('beforeunload', () => {
        params = {id_wpis: this.editedId}
        this.deleteEdytowane({params})
      }, false)
    }
  },
  beforeDestroy() {
    let params = {id_wpis: this.editedId}
    this.deleteEdytowane({params})
  },
  components: {},
};
</script>

<style>

.redIcon{
  color: #8b0000;
  cursor: pointer;
}

.greenIcon{
  color: #015a05;
  cursor: pointer;
}

.repeatedPart {
  border-radius: 2px;
  border: solid 2px #004b8b;
  padding: 10px 15px;
}

.indent{
  margin-left:15px;
}

.searchSelect {
  height: 35px !important;
}

.formStyle {
  width: 80%;
  padding: 5%;
  border: 1px solid black;
  text-align: left;
  border-radius: 10px;
  box-shadow: 0px 0px 15px #a8a9aa;
  margin: auto;
}

.formStyle div {
  margin-bottom: 20px;
}

.formStyle div br {
  margin-bottom: 3px;
}

.textareaForm {
  resize: vertical;
  font-size: 16px;
  width: 100%;
  border: solid 1px #dbdbdb;
  border-radius: 5px;
  font-family: Georgia;
  padding: 6px;
}

.dateForm{
  border: solid 1px #dbdbdb;
  border-radius: 5px;
  font-family: Georgia;
  font-size: 16px;
  padding: 6px;
}

.shortText {
  width: 100%;
  border: solid 1px #dbdbdb;
  border-radius: 5px;
  font-size: 16px;
  font-family: Georgia;
}

.linkGrid {
  display: grid;
  grid-template-columns: 65px auto;
  margin-bottom: 3px;
}

.twoGrid {
  display: grid;
  grid-template-columns: auto 20px;
  margin-bottom: 3px;
}

.control_group {
  /* margin-left: 50px; */
}
.control {
  display: block;
  position: relative;
  padding-left: 30px;
  margin-bottom: 4px;
  padding-top: 0px;
  cursor: pointer;
  font-size: 16px;
}
.control input {
  position: absolute;
  z-index: -1;
  opacity: 0;
}
.control_indicator {
  position: absolute;
  top: 2px;
  left: 0;
  height: 20px;
  width: 20px;
  background: #e6e6e6;
  border: 0px solid #000000;
  border-radius: 0px;
}
.control:hover input ~ .control_indicator,
.control input:hover ~ .control_indicator {
  background: #cccccc;
}

.control input:checked ~ .control_indicator {
  background: #240c83;
}
.control:hover input:not([disabled]):checked ~ .control_indicator,
.control input:checked:hover ~ .control_indicator {
  background-color: #240c83a2;
}
.control input:disabled ~ .control_indicator {
  background: #e6e6e6;
  opacity: 0.6;
  pointer-events: none;
}
.control_indicator:after {
  box-sizing: unset;
  content: "";
  position: absolute;
  display: none;
}
.control input:checked ~ .control_indicator:after {
  display: block;
}
.control-checkbox .control_indicator:after {
  left: 8px;
  top: 4px;
  width: 3px;
  height: 8px;
  border: solid #ffffff;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}
.control-checkbox input:disabled ~ .control_indicator:after {
  border-color: #7b7b7b;
}
.file {
    display: none;
  }
.file-listing {
    display: grid;
    grid-template-columns: 1fr 0.1fr;
    width: 70%;
    border-bottom: 1px dotted grey;
  }
  .padding {
    padding: 3px;
  }
  .remFile {
    justify-self: center;
    cursor: pointer;
    color: red;
    font-weight: bolder;
  }
  .download:hover {
    text-decoration: underline;
    cursor: pointer;
    color: blue;
  }

  /* sidebar */
    .slide-enter-active,
    .slide-leave-active {
        transition: transform 0.2s ease;
    }

    .slide-enter,
    .slide-leave-to {
        transform: translateX(-100%);
        /* -100% */
        transition: all 150ms ease-in 0s;
    }

    .sidebar-panel {
        overflow-x: none;
        overflow-y: none;
        background-color: #ffffff;
        box-shadow: -1px -1px 5px #a8a9aa;
        position: fixed;
        left: 0;
        /* left */
        top: 160px;
        /* height: 100vh;*/
        height: fit-content; 
        min-height: 400px;
        z-index: 999;
        padding: 20px;
        width: 200px;/*14%;*/
    }
    ul.sidebar-panel-nav {
      padding: 0px;
      margin: 0px;
    }

  ul.sidebar-panel-nav>li {
    color: black;
    font-size: 15px;
    display: block;
    cursor:pointer;
    margin-bottom: 7px;
  }
  ul.sidebar-panel-nav>li:hover{
    color:#2b5483;
    text-decoration: underline;
  }

  .sidebar-tag{
    width:20px; 
    top:0px; 
    left:100%; 
    background-color:white; 
    position:absolute;  
    border-radius:0px 5px 5px 0px; 
    cursor:pointer; 
    border: solid 2px #004b8b;
    border-left:none;
  }

  .sidebar-tag div{
    margin-right:6px; 
    margin-top:10px; 
    transform:rotate(90deg); 
    cursor:pointer;
  }

  .hideShow:hover {
    cursor: pointer;
    color: #6593c7;
    /* text-decoration: underline; */
  }

  .hideShow{
    color: #004b8b;
    float: right;
    margin-top: 4px;;
  }
</style>